/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {useId} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Text, Box, Button, SimpleGrid} from '@chakra-ui/react'
import usePromoCodeFields from './usePromoCodeFields'
import Field from '../field'
import {useWatch} from 'react-hook-form'

const PromoCodeFields = ({form, prefix = '', ...props}) => {
    const fields = usePromoCodeFields({form, prefix})
    const code = useWatch({control: form.control, name: 'code'})
    const promoCodeError = form.formState.errors?.[fields.code.name]?.message
    const id = useId()

    return (
        <Box {...props}>
            <SimpleGrid
                spacing={2}
                autoFlow="column"
                autoColumns="1fr"
                alignItems="flex-end"
                {...props}
            >
                <Field
                    {...fields.code}
                    suppressErrorMessage
                    inputProps={{
                        ...fields.code.inputProps,
                        'aria-describedby': `${id}-feedback`
                    }}
                />

                <Button
                    type="submit"
                    isLoading={form.formState.isSubmitting}
                    disabled={code?.length < 3}
                >
                    <FormattedMessage defaultMessage="Apply" id="promo_code_fields.button.apply" />
                </Button>
            </SimpleGrid>

            <Text id={`${id}-feedback`} mt={2} color="stokkeFunctional.alertRed">
                {promoCodeError || ''}
            </Text>
        </Box>
    )
}

PromoCodeFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default PromoCodeFields
